<template>
  	<el-row class="container" style="position:absolute;">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
				{{collapsed?'':sysName}}
			</el-col>
			<el-col :span="1">
				<div class="tools" @click.prevent="collapse">
					<i class="fa fa-align-justify"></i>
				</div>
			</el-col>
			<el-col :span="8" class="userinfo">
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner"><img src="../assets/logo.png" /> {{sysUserName}}</span>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item>我的消息</el-dropdown-item>-->
						    <el-dropdown-item @click.native="editFormVisible=true">修改密码</el-dropdown-item>
						<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'" style="height:100%">
				<!--导航菜单-->			
			<!-- 支持多级-->	
			

			<el-menu :default-active="$route.path" router  unique-opened v-show="!collapsed" class="el-menu-vertical-demo"
			background-color="#eef1f6" style="width:200px;" text-color="#000"  active-text-color="#20a0ff">
				<menuitems v-for="(model,index) in submenus" :key="index" :model="model"></menuitems>		
			</el-menu>	
             
                <!--支持两级-->		 
			<!-- 	<el-menu :default-active="$route.path"   class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
					 unique-opened router v-show="!collapsed" ref="m">
					<template v-for="(item,index) in submenus" >
						<el-submenu :index="index+''" v-if="item.children.length>0"  :ref="'s'+index">
							<template slot="title"><i :class="item.icon"></i>{{item.title}}</template>
							<el-menu-item v-for="child in item.children" :index="child.path" >{{child.title}}</el-menu-item>
						</el-submenu>
						<el-menu-item v-if="item.children.length==0" :index="item.path"><i :class="item.icon"></i>{{item.title}}</el-menu-item>
					</template>
				</el-menu>	 -->
			   
				<!--导航菜单-折叠后-->
				<ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
					
					<li v-for="(item,index) in submenus" :key="index" class="el-submenu item">					
						<template v-if="item.children.length>0">
							<div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"><i :class="item.icon"></i></div>
							<ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"> 
								<li v-for="(child,j) in item.children" :key="j" class="el-menu-item" style="padding-left: 40px;height: 56px;background-color:#BEC1C5" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">{{child.title}}</li>
							</ul>
						</template>
					
						<template v-else-if="item.children.length==0">
							<li class="el-submenu">
								<div class="el-submenu__title" style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;" :class="$route.path==item.path?'is-active':''" @click="$router.push(item.path)"><i :class="item.icon"></i></div>
							</li>
						</template>
					</li>
				</ul>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container" v-show="$route.path=='/error'?false:true">
						<strong class="title">{{$route.name}}</strong>
						<el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="(item,index) in $route.matched" :key="index">
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
		 <!--修改密码-->
		  <el-dialog title="修改密码" v-model="editFormVisible" :close-on-click-modal="false"  size="tiny">
			<el-form :model="editForm"   label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="旧密码" prop="old_password">
					<el-input type="password" v-model="editForm.old_password" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="new_password">
				     <el-input type="password" v-model="editForm.new_password" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="确认新密码" prop="confirm_password">
					<el-input type="password" v-model="editForm.confirm_password" placeholder="" auto-complete="off" ></el-input>
				</el-form-item>		
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
			</section>
		</el-col>
	</el-row>
</template>

<script>
import menuitems from '@/components/MenuItems.vue' 
import { requestMenu,updatePassword } from '../api/api';

 let CurrentUserID="",Session=""; 
  
export default { 
 components: { 'menuitems':menuitems },
data() {
	   
	var validateNew = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } else {
          if (this.editForm.confirm_password !== '') {
            this.$refs.editForm.validateField('confirm_password');
          }
          callback();
        }
      };
     var checkPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入新密码'));
        } else if (value !== this.editForm.new_password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
   return {
				sysName:'系统管理',
				collapsed:false,
				sysUserName: '',
				sysUserAvatar: '',
				submenus:JSON.parse(sessionStorage.getItem('menu')),
				editFormVisible: false,
				editLoading: false,
				editForm:{
					old_password:'',
					new_password:'',
					confirm_password:''
				},
				editFormRules: {
					old_password: [
						{ required: true, message: '请输入旧密码', trigger: 'blur' }
					],
					new_password: [
						{ required: true,validator:validateNew, trigger: 'blur' }
					],
					confirm_password: [
						{ required: true,validator:checkPass, trigger: 'blur'}
					],
				}

			}   

		},
		methods: {
	
			// handleopen(key, keyPath) {
			// 	console.log('handleopen');
			// },
			// handleclose(key, keyPath) {
			// 	console.log('handleclose');
			// },
			// handleselect: function (key, keyPath) {
            
            //     // var select;
			// 	// endfor:
			// 	// for(var i=0; i<this.submenus.length; i++)  
			// 	// {  
			// 	//     if (key==this.submenus[i].path)
			// 	// 	{
			// 	// 		 select=this.submenus[i];
			// 	// 		 break endfor; 
			// 	// 	}
			// 	// 	for(var j=0;j<this.submenus[i].children.length;j++)
			// 	// 	{
			// 	// 		if (key==this.submenus[i].children[j].path)
			// 	// 		{
            //     //              select=this.submenus[i].children[j];
			// 	// 			 break endfor; 
			// 	// 		}
			// 	// 	}
				
			// 	// }  
                
		
			// 	// this.$router.push({ path: key, query: {menu_id: select.menu_id}})
			// },
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					sessionStorage.removeItem('user');
					_this.$router.push('/login');
				}).catch(() => {

				});


			},
			//折叠导航栏
			collapse:function(){
				this.collapsed=!this.collapsed;
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
				
			},
			//修改密码
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para["sys_type"] = "3";
							para["CurrentUserID"] = CurrentUserID;
							para["session"]=Session;

                this.$http.jsonp(updatePassword, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							    
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});								
				
								  this.editFormVisible = false;					
                           
                         }
                         else{                           
                             	this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }

							  if (res.data.result_code==915)
							  {
									this.$message({
										message:'旧密码输入错误',
										type: 'error'
									});
                                  return;
							  }
							if (res.data.result_code==916)
							  {
									this.$message({
										message:'两次输入的新密码不一致',
										type: 'error'
									});
                                  return;
							  }
						
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'错误',
                                type: 'error'
                              });
                      this.editLoading = false;	
                   }
           )

						});
					}
				});
			},
		},

		mounted() {
			  
			var user = sessionStorage.getItem('user');
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session');  
				
			if (user) {
				user = JSON.parse(user);
				this.sysUserName = user.nickname || '';
				
			}       
          
			
		// 	this.$http.jsonp(requestMenu,{params: {CurrentUserID: CurrentUserID,SysType:3,Session:Session }}).then(
        //            function(res){                         
        //                  if (res.data.result_code==200)
        //                  {
        //                      this.submenus=res.data.menu;
		// 					 this.submenus.splice(0, 0, {"menu_id":0,"menu_code":"","parent_code":"","title": "首页","path": "/home","icon":"el-icon-menu",children: []})
        //                      this.$refs.m.defaultActive=this.$route.path;
		// 					 this.$refs.m.initOpenedMenu();
		// 					  this.$refs.m.openMenu('/jumpparam', '1,/jumpparam');
		// 					   alert(this.$refs.s0.rootMenu.openedMenus);
							 
		// 				 }
        //                  else{                           
                              
		// 					  if (res.data.result_code==911)
		// 					  {
        //                           this.$router.push({ path: "/login"});
		// 						  return;
		// 					  }

        //                       if (res.data.result_code==600)
		// 					  {
		// 							this.$message({
		// 								message:'接口错误',
		// 								type: 'error'
		// 							});
        //                           return;
		// 					  }
							
        //                  }
                       

        //            },
        //            function(res)
        //            {
        //                 this.$message({
        //                         message:'接口访问失败',
        //                         type: 'error'
        //                       });
                      
        //            }
        //    )

		  

		}
  }


</script>

<style >

.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		}

.header {
			height: 60px;
			line-height: 60px;
			background: #20a0ff;
			color:#fff;
		}

.header .userinfo {
				text-align: right;
				padding-right: 35px;
				float: right;	
			}

.header .userinfo .userinfo-inner {
					cursor: pointer;
					color:#fff;
					
				}

.header .userinfo .userinfo-inner img {
		width: 40px;
		height: 40px;
		border-radius: 20px;
		margin: 10px 0px 10px 10px;
		float: right;
	}

.header .logo {
				
				height:60px;
				font-size: 22px;
				padding-left:20px;
				padding-right:20px;
				border-color: rgba(238,241,146,0.3);
				border-right-width: 1px;
				border-right-style: solid;

				
			}
.header .logo img {
			width: 40px;
			float: left;
			margin: 10px 10px 10px 18px;
		  } 

.header .logo .txt {
					color:#fff;
		}
.header .logo-width{
			width:200px;
		}
.header .logo-collapse-width{
			width:60px
		}
.header .tools{
			padding: 0px 23px;
			width:14px;
			height: 60px;
			line-height: 60px;
			cursor: pointer;
		}

.container .main {
			display: flex;		
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
		}	


.main aside {
				flex:0 0 200px;
				width: 200px;

			}

.main aside .el-menu{
					height: 100%;
				}

.main aside .el-submenu__title:hover{
					background-color: #BEC1C5;
				}

.main aside .collapsed{
			width:60px;
			background-color: #eef1f6;		
		}
.main aside .collapsed .item{
				position: relative;
			}
.main aside .collapsed .submenu{
				position:absolute;
				top:0px;
				left:60px;
				z-index:99999;
				height:auto;
				display:none;
			}

.main .menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}
.main .menu-expanded{
				flex:0 0 200px;
				width: 200px;
			}

.main .content-container {				
				flex:1;				
				overflow-y: scroll;
				padding: 20px;
			}

.main .content-container .content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}

.main .content-container .breadcrumb-container {}
.main .content-container .breadcrumb-container .breadcrumb-inner {
						float: right;
					}

.main .content-container .breadcrumb-container .title {
						width: 200px;
						float: left;
						color: #475669;
					}




	
</style>


// WEBPACK FOOTER //
// main.vue?53ff69b7